export const pressBaseUrl = {
  de: `${process.env.NEXT_PUBLIC_NEXT_BASE_URL}/presse`,
  en: `${process.env.NEXT_PUBLIC_NEXT_BASE_URL}/en/press`,
}
